import { render, staticRenderFns } from "./ViewContainer.vue?vue&type=template&id=b2ea62f2&scoped=true&"
import script from "./ViewContainer.vue?vue&type=script&lang=js&"
export * from "./ViewContainer.vue?vue&type=script&lang=js&"
import style0 from "./ViewContainer.vue?vue&type=style&index=0&id=b2ea62f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea62f2",
  null
  
)

export default component.exports